import { render, staticRenderFns } from "./FacebookLogout.vue?vue&type=template&id=9ec7f7ce&"
import script from "./FacebookLogout.vue?vue&type=script&lang=js&"
export * from "./FacebookLogout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports